import type React from 'react';
import type { BasicContentBlockA } from '@course-authoring/shared-types';
import { BasicContentBlockRenderer } from './BasicContentBlockRenderer';

export interface BasicContentBlockARendererProps {
  block: BasicContentBlockA;
  className?: string;
}
export function BasicContentBlockARenderer({
  block,
  className,
}: BasicContentBlockARendererProps): React.ReactElement {
  return <BasicContentBlockRenderer block={block} className={className} />;
}

BasicContentBlockARenderer.displayName = 'BasicContentBlockARenderer';
